angular.module("vgresiduos").controller("JobPositionCtrl", [
	"$scope",
	"$rootScope",
	"$q",
	"httpService",
	"jobPositionService",
	function ($scope, $rootScope, $q, httpService, jobPositionService) {
		"use strict";

		const labels = $rootScope.labels;
		let isListLoaded;

		this.$onInit = function () {
			initLabel();

			$scope.helpInfo = $scope.$ctrl.helpInfo ? $scope.$ctrl.helpInfo : null;
			loadJobPositions().then(setJobPosition);
		};

		function initLabel() {
			$scope.label = $scope.$ctrl.label ? $scope.$ctrl.label : labels.JOB_POSITION;

			if ($scope.$ctrl.isRequired) {
				$scope.label += "*";
			}
		}

		function loadJobPositions() {
			const deferred = $q.defer();

			if (isListLoaded) {
				deferred.resolve();
				return deferred.promise;
			}

			httpService.getListFromServiceCore(jobPositionService.getJobPositions).then(
				function (response) {
					$scope.jobPositions = response.list;
					isListLoaded = true;
					deferred.resolve();
				},
				function () {
					deferred.reject();
				}
			);

			return deferred.promise;
		}

		function setJobPosition() {
			if ($scope.$ctrl.setterId) {
				const foundPosition = $scope.jobPositions.find((position) => position.id == $scope.$ctrl.setterId);
				if (foundPosition) {
					$scope.$ctrl.model = foundPosition.id;
				}
			} else if ($scope.$ctrl.selectAutoWhenOneOption && $scope.jobPositions.length == 1) {
				$scope.$ctrl.model = $scope.jobPositions[0].id;
			}
		}

		$scope.isDisabled = function () {
			return $scope.$ctrl.isDisabled ? $scope.$ctrl.isDisabled : false;
		};

		$scope.$watch("$ctrl.setterId", function (newValue, oldValue) {
			const modelId = $scope.$ctrl.model;

			if (newValue != modelId) {
				loadJobPositions().then(setJobPosition);
			}
		});
	}
]);
